import { useQuery } from '@tanstack/react-query';

import { statsApi } from '../stats.api';

import { StatsQueryParams } from './types';

export const useQueryStatsMTTR = ({
  dateTo,
  fromUnitType,
  fromValue,
  aircraftsIdList = [],
}: StatsQueryParams) => {
  const enabled = ![fromUnitType, fromValue, dateTo].some(v => v === undefined);
  const dateToString = dateTo.toISOString();
  return useQuery({
    queryKey: [
      'StatsMTTR',
      fromValue,
      fromUnitType,
      dateToString,
      aircraftsIdList,
    ],
    queryFn: async () =>
      statsApi.getMttr({
        dateTo,
        fromValue,
        fromUnitType,
        aircraftsIdList,
      }),
    select: data => data,
    enabled,
  });
};
